webpackJsonp([54478762516702],{

/***/ 433:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Collections = __webpack_require__(25);
	
	var _Collections2 = _interopRequireDefault(_Collections);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Collections2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'add'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'add()'
	      ),
	      ' method can be used to add models to the collection outside the constructor.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Default Implementation'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The default implementation looks like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      add: function(models, options) {\n        return this.set(models, _.extend({}, options));\n      },\n      ' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Usage'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Let\'s save you\'ve created a collection like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      import { Collection } from \'lore-models\';\n\n      const TweetCollection = Collection.extend({\n        url: \'http://localhost:1337/tweets\'\n      })\n\n      const tweets = new TweetCollection()\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'add()'
	      ),
	      ' method can be used add additional models to the collection, and there are two ways to call it.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The first is by providing a object, like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      tweets.add({\n        id: 1,\n        text: \'Some new tweet\'\n      })\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The second is by providing an array, like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      tweets.add([\n        {\n          id: 1,\n          text: \'Some new tweet\'\n        }\n      ])\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In both cases, if you now examined the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'tweet.models'
	      ),
	      ' property you would see this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      [\n        new Model({\n          id: 1,\n          text: \'Some new tweet\'\n        })\n      ]\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-collections-properties-add-js-473f2e6776414fe01dfe.js